import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { LoadingOutlined } from '@ant-design/icons';

import './styles.less';

export const ActionButton = ( props ) => {

    const isDisabled = useMemo( () => {
        return ( Boolean( props.disabled ) || Boolean( props.loading ) );
    }, [ props.disabled, props.loading ] );

    const isInteractable = useMemo( () => {
        return ( Boolean( props.interactable ) && !isDisabled );
    }, [ props.interactable, isDisabled ] );

    // Construct the classes to use for the root component.
    const classes = classnames(
        'action-button',
        { 'disabled': isDisabled },
        { 'interactable': isInteractable },
        { 'loading': Boolean( props.loading ) },
        { 'animate': Boolean( props.animate ) },
        { 'important': Boolean( props.important ) },
        { 'subtle': Boolean( props.subtle ) },

        // Predefined color styles
        { 'blue': Boolean( props.blue ) },
        { 'green': Boolean( props.green ) },
        { 'gray': Boolean( props.gray ) },

        { [ props.className ]: Boolean( props.className ) },
    );
    
    return (
        <button
            type={ props?.type }
            tabIndex={ ( props.disabled || !props.interactable ) ? -1 : 0 }
            className={ classes }
            onClick={ ( isInteractable && !props.loading && !props.disabled ) ? props.onClick : undefined }
        >
            <div className="action-button-content">
                <div className="action-button-content-loading">
                    <LoadingOutlined className="action-button-spinner" />
                </div>
                <div className="action-button-content-body">
                    { props.children }
                </div>
            </div>
        </button>
    );
};

ActionButton.defaultProps = {
    className: undefined,
    loading: false,
    disabled: false,
    animate: true,
    interactable: true,
    onClick: undefined,

    blue: true,
    green: false,
    gray: false,
    important: false,
    subtle: false,
};

ActionButton.propTypes = {
    className: PropTypes.string,
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    animate: PropTypes.bool,
    interactable: PropTypes.bool,
    onClick: PropTypes.func,

    blue: PropTypes.bool,
    green: PropTypes.bool,
    gray: PropTypes.bool,
    important: PropTypes.bool,
    subtle: PropTypes.bool,
};
